import { Span } from 'opentracing';
import {
  WEBSITE_ORIGIN_POD_TAG,
  getWebsiteOriginPod,
} from '../website-origin-pod';

export function addWebsiteOriginPodTag(span: Span) {
  span.setTag(WEBSITE_ORIGIN_POD_TAG, getWebsiteOriginPod());
}
